import template from './labelsSelectedList.template.html';

export default {
  template,
  bindings: {
    labels: '=',
    selectedLabels: '<',
    size: '<',
    isSameSize: '<',
    limit: '<'
  },
controller: class controller {
    constructor($rootScope, $mdMedia) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.$mdMedia = $mdMedia;
      ctrl.availableLabels = [];

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        if (ctrl.selectedLabels && ctrl.selectedLabels.length) {
          for (let i = 0; i < ctrl.selectedLabels.length; i += 1) {
            const idx = _.findIndex(ctrl.labels, (l) => l.id === ctrl.selectedLabels[i]);
            if (idx > -1 && ctrl.availableLabels.indexOf(ctrl.selectedLabels[i]) === -1) {
              ctrl.availableLabels.push(ctrl.selectedLabels[i]);
            }
          }
        }
      };
      ctrl.getLabel = (idLabel) => _.find(ctrl.labels, (label) => label.id === idLabel);

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = function () {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      ctrl.$onChanges = function (changes) {
        if (
          changes &&
          changes.selectedLabels.currentValue &&
          changes.selectedLabels.previousValue.length !==
            changes.selectedLabels.currentValue.length
        ) {
          ctrl.availableLabels = [];
          ctrl.initialize();
        }
      };
    }
  }
};
